<button
  {{ attributes.attributes }}
  class="{{ attributes.classes }} {{#if (equal attributes.disabled 'disabled')}}disabled{{/if}}">
    {{~#if attributes.iconBefore}}
      {{>icon uuid=attributes.cid icon=attributes.iconBefore}}
    {{/if~}}
    {{#if attributes.txt}}{{t attributes.txt}}{{/if}}
    {{~#if attributes.iconAfter}}
      {{>icon uuid=attributes.cid icon=attributes.iconAfter}}
    {{/if~}}
    {{~#if attributes.afterContent}}
      {{{attributes.afterContent}}}
    {{/if~}}
    {{~#if attributes.blocksRegion }}
      <div style="pointer-events:none;" data-region="{{ attributes.blocksRegion }}"></div>
    {{/if~}}
    {{~#if attributes.contentInjection}}
      {{{attributes.injectedContent}}}
    {{/if~}}
</button>
